import { Container } from "@mui/material";
import classes from "./Button.module.scss"

const NotImplemented = () =>{
    return(
        <>
        <div className={`w-100 ${classes.notImplementedContainer}`}>
            <span className={`${classes.notImplementedText}`}>Not implemented</span>
        </div>
        </>
    )
}

export default NotImplemented;